import { ReduxState } from '@batical/reducer/src/reducers'
import { selectUserId } from '@batical/reducer/src/User/UserSelector'
import { getUnixTime } from 'date-fns'
import { createSelector } from 'reselect'

export const selectSubscription = (state: ReduxState) => state.subscription
export const selectSubscriptionStripeId = (state: ReduxState) => state.subscription.stripeSubscriptionId
export const selectSubscriptionStripeDistributorId = (state: ReduxState) => state.subscription.offerBySubscriptionId

//TODO ROBIN : qjcfzhLk6Udt5ZDAGF9g0wCKkCR2
//todo Sugus guigui : VUvdVjsOm5NPhvoMULzBaaewshf2
const ALWAYS_SUBSCRIBER_USER_IDS = new Set([
  'qjcfzhLk6Udt5ZDAGF9g0wCKkCR2',
  'TFaNMMYA08V0q7dx4SUdHVdnVjD3', // guillaume.calderini@airotherm.fr
  'vXprYVXKuYaLeXdhIXT4fvFBfHx2' // shecart.mydev@gmail.com
])

export const selectSubscriptionExpirationMaxUnix = createSelector([selectSubscription], sub =>
  Math.max(sub.expirationDate ?? 0, sub.expirationDateStripe ?? 0, sub.expirationDateDistributor ?? 0)
)

/** Uses current time; safe with useSelector — recomputes each render. */
export const selectIsSubscriber = (state: ReduxState): boolean => {
  const userId = selectUserId(state)
  if (ALWAYS_SUBSCRIBER_USER_IDS.has(userId)) {
    return true
  }
  return selectSubscriptionExpirationMaxUnix(state) > getUnixTime(new Date())
}
